/**
 * @generated SignedSource<<8e438726ee554b0daca048ba04f18906>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionCardContentfulRelayFragment$data = {
  readonly collectionIcon: {
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly collectionNameExternal: string | null | undefined;
  readonly howToUseThisCollection: {
    readonly collectionStepsCollection: {
      readonly __typename: "CollectionGuideCollectionStepsCollection";
      readonly total: number;
    } | null | undefined;
  } | null | undefined;
  readonly sys: {
    readonly id: string;
  };
  readonly urlSlug: string | null | undefined;
  readonly " $fragmentType": "collectionCardContentfulRelayFragment";
};
export type collectionCardContentfulRelayFragment$key = {
  readonly " $data"?: collectionCardContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"collectionCardContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "collectionCardContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Sys",
      "kind": "LinkedField",
      "name": "sys",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "collectionNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlSlug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Asset",
      "kind": "LinkedField",
      "name": "collectionIcon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CollectionGuide",
      "kind": "LinkedField",
      "name": "howToUseThisCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionGuideCollectionStepsCollection",
          "kind": "LinkedField",
          "name": "collectionStepsCollection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TemplateCollection",
  "abstractKey": null
};

(node as any).hash = "d8241124bca686ed67a1144a13588d49";

export default node;
